import { formatNumber } from "src/MarketDataComponents/Helpers";

export default function KeyStatistics({keyStatistics}) {
    return keyStatistics ? <div className="ajb-grid-row">
        <div className="ajb-col-collapse">
            <div className="ajb-col-12 ajb-col-8-breakpoint">
                <div className="card z-depth-0 margin-0">
                    <div className="card-content padding-top-0-sm padding-right-0-sm padding-bottom-30-sm padding-left-0-sm">
                        <span className="card-title" data-testid="keyStatisticsHeader">Key statistics (GBP)</span>
                        <table className="data-table data-table--small data-table--scroll margin-top-0 margin-bottom-0 margin-bottom-30-sm">
                            <tbody>
                                <tr>
                                    <td data-testid="keyStatisticsTotalAssetsLabel">Total assets</td>
                                    <td className="text-align-right" data-testid="keyStatisticsTotalAssetsValue">{!isNaN(keyStatistics.totalAssets) ? formatNumber((keyStatistics.totalAssets/1000000), 3) + 'm' : '-'}</td>
                                </tr>
                                <tr>
                                    <td data-testid="keyStatisticsNetAssetsLabel">Net assets</td>
                                    <td className="text-align-right" data-testid="keyStatisticsNetAssetsValue">{!isNaN(keyStatistics.netAssets) ? formatNumber((keyStatistics.netAssets/1000000), 3) + 'm' : '-'}</td>
                                </tr>
                                <tr>
                                    <td data-testid="keyStatisticsGrossGearingLabel">Gross gearing</td>
                                    <td className="text-align-right" data-testid="keyStatisticsGrossGearingValue">{!isNaN(keyStatistics.grossGearing) ? keyStatistics.grossGearing + '%' : '-'}</td>
                                </tr>
                                <tr>
                                    <td data-testid="keyStatisticsNetGearingLabel">Net gearing</td>
                                    <td className="text-align-right" data-testid="keyStatisticsNetGearingValue">{!isNaN(keyStatistics.netGearing) ? keyStatistics.netGearing + '%' : '-'}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div> : null
}
